export const GovernanceFields = {
  if: (el) => el.getRootState('email').endsWith('@symbols.app'),
  flow: 'x',
  gap: 'C',
  childProps: {
    gap: 'Y',
    Icon: {
      color: 'placeholder'
    }
  },
  margin: '- B2 - auto',
  childExtends: ['IconText', 'DropdownParentFocus'],
  Env: {
    icon: 'fuse',
    Icon_arrow: {
      // eslint-disable-next-line no-restricted-syntax -- dropdown chevron glyph, not text
      color: 'inactive',
      name: 'arrow angle down'
    },
    Dropdown: {
      hide: (el) => !el.getAppKey(),
      top: 'B',
      left: '0',
      align: 'start',
      ListInDropdown: {
        childExtends: ['Link'],
        onClick: (ev) => ev.stopPropagation(),
        childProps: {
          textAlign: 'start',
          padding: 'Z1 A',
          color: 'inactive',
          round: 'radiusPill',
          theme: null,
          fontWeight: '400',
          align: 'center start',
          Icon: {
            order: 2,
            margin: '- - - auto'
          },
          ':hover': {
            theme: 'field'
          },
          '.isActive': {
            theme: 'field'
          }
        },
        childrenAs: 'props',
        children: () => [
          {
            href: `https://dev.symbols.app${window.location.pathname}`,
            target: '_blank',
            text: '{{ settings.governance.env.development | polyglot }}'
          },
          {
            href: `https://staging.symbols.app${window.location.pathname}`,
            target: '_blank',
            text: '{{ settings.governance.env.staging | polyglot }}'
          },
          {
            href: `https://symbols.app${window.location.pathname}`,
            target: '_blank',
            text: '{{ settings.governance.env.production | polyglot }}'
          }
        ]
      }
    },
    text: (el) => el.getRootState('evn')
  },
  PlatformVersion: {
    icon: 'state',
    text: 'v',
    onRender: async (el) => {
      // getPlatformVersion() legitimately resolves undefined right now (see
      // its own comment in shared/methods/root.js — the version import is
      // disabled pending a separate bundler decision). Concatenating that
      // straight into the label rendered the literal "vundefined" on every
      // app that mounts GovernanceFields, catalog or not. Guard so the
      // honest "no version resolved yet" state is an empty suffix, not a
      // stringified `undefined`.
      const version = await el.getPlatformVersion()
      el.update({
        text: version ? `v${version}` : 'v'
      })
    },
    Icon_arrow: {
      // eslint-disable-next-line no-restricted-syntax -- dropdown chevron glyph, not text
      color: 'inactive',
      name: 'arrow angle down'
    },
    Dropdown: {
      hide: (el) => !el.getAppKey(),
      top: 'B',
      left: '0',
      align: 'start',
      ListInDropdown: {
        childExtends: ['Link'],
        onClick: (ev) => ev.stopPropagation(),
        childProps: {
          textAlign: 'start',
          padding: 'Z1 A',
          color: 'inactive',
          round: 'radiusPill',
          theme: null,
          fontWeight: '400',
          align: 'center start',
          Icon: {
            order: 2,
            margin: '- - - auto'
          },
          ':hover': {
            theme: 'field'
          },
          '.isActive': {
            theme: 'field'
          }
        },
        childrenAs: 'props',
        children: () => [
          {
            href: (el) =>
              'https://github.com/symbo-ls/platform/commits/' + `v${el.getPlatformVersion()}`,
            target: '_blank',
            text: '{{ settings.governance.link.commit | polyglot }}'
          },
          {
            href: (el) =>
              ({
                production: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Aworkflow_dispatch`,
                staging: `https://github.com/symbo-ls/platform/actions?query=branch%3Av${el.getPlatformVersion()}+event%3Arelease`,
                development: `https://github.com/symbo-ls/platform/actions`
              })[el.getRootState('env')],
            target: '_blank',
            text: '{{ settings.governance.link.workflow | polyglot }}'
          },
          {
            href: (el) =>
              'https://github.com/symbo-ls/platform/tree/refs/tags/' +
              `v${el.getPlatformVersion()}`,
            target: '_blank',
            text: '{{ settings.governance.link.code | polyglot }}'
          },
          {
            target: '_blank',
            text: '{{ settings.governance.link.releaseNotes | polyglot }}',
            href: (el) =>
              'https://github.com/symbo-ls/platform/releases' + `?after=v${el.getPlatformVersion()}`
          }
        ]
      }
    }
  }
}
